import { Partner } from "features/settings/importMapping/partner";

export default class PartnerIntegration {
    merchantId: string;
    externalId: string;
    partner: Partner;
    partnerName: string;
    authenticationKey: string;  
    isHedgeOrderExportSupported: boolean;  
    configuration?: any;
}

